import {connect} from 'react-redux';

// micro-scholarships
import MicroScholarships from '../components';
import {setNavigationAnnouncement} from 'shared/actions/accessibility-announcement';
import {startLoading} from 'shared/actions/loading';
import {bindActionCreators} from 'redux';

const mapStateToProps = ({microscholarshipsLoading}) => ({
  loading: microscholarshipsLoading,
});

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators({setNavigationAnnouncement, startLoading}, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(MicroScholarships);
